import React from "react"

function IconMicrophoneSlash({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="microphone-slash"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-microphone-slash"
      {...props}
    >
      <path
        d="M5.531 10.581c.362 0 .655.293.655.655a5.837 5.837 0 0 0 8.161 5.357l1.023.959a7.101 7.101 0 0 1-2.692.8v2.71a.655.655 0 0 1-1.3.106l-.01-.106v-2.71a7.147 7.147 0 0 1-6.491-7.116c0-.362.293-.655.654-.655zm12.984 0c.362 0 .655.293.655.655a7.114 7.114 0 0 1-1.201 3.967l-.97-.911a5.81 5.81 0 0 0 .862-3.056c0-.362.293-.655.654-.655zM8.4 11.016l1.586 1.488c.243.455.63.82 1.102 1.033l1.567 1.469A3.655 3.655 0 0 1 8.4 11.4v-.384zm3.656-8.507a3.655 3.655 0 0 1 3.654 3.655V11.4c0 .502-.101.98-.284 1.416l-1.062-.996c.014-.083.025-.167.031-.252l.006-.168V6.164a2.345 2.345 0 0 0-4.685-.168l-.006.168v1.293L8.398 6.23l.001-.066a3.655 3.655 0 0 1 3.655-3.655z"
        fill={color}
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
      <path
        d="M2.795 3.37a.655.655 0 0 1 .832-.102l.093.073 17.455 16.363a.655.655 0 0 1-.802 1.028l-.093-.073L2.825 4.296a.655.655 0 0 1-.03-.925z"
        fill={color2 || color}
        fillRule="nonzero"
        style={{ height: height || fontSize }}
        originalclass="__danger"
      />
    </svg>
  )
}

export default IconMicrophoneSlash
